export enum PartyType {
  NATURAL_PERSON = 'NP',
  LEGAL_ENTITY = 'LE',
  NATURAL_PERSON_GROUP = 'NPG'
}
